import React from "react";
import { connectInfiniteHits } from "react-instantsearch/connectors";
import ArticleView from "../ArticleView";

function ConnectedArticleView({ hits, hasMore, refine }) {
  return <ArticleView articles={hits} hasMore={hasMore} refine={refine} />;
}

export default connectInfiniteHits(ConnectedArticleView);



// WEBPACK FOOTER //
// ./src/ConnectedArticleView/ConnectedArticleView.js